import React from "react";
import moment from "moment";

const initialState = {
  insurance: {
    id: null,
    startDate: moment()
      .add(1, "days")
      .toDate(),
    expirationDate: moment()
      .add(2, "days")
      .toDate(),
    createdDate: "",
    pickedSports: [{ value: "", id: 0 }],
    sports: [],
    location: "",
    coverage: 0,
    telemedecine: false,
    creator: {
      id: null,
      role: null,
      email: "",
      phone: "",
      firstName: "",
      lastName: "",
      middleName: "",
      birthday: moment().toDate(),
    },
    insurers: [],
    packet: {
      includeList: [],
    },
    totalPrice: 0,
    isCompetition: false,
    step: 0,
    signedIn: false,
    loading: false,
    errors: [],
  },
  sports: [],
  signup: {
    token: null,
    user: {
      id: null,
      role: null,
      email: "",
      firstName: "",
      lastName: "",
      middleName: "",
      birthday: null,
      passportID: "",
      passportSeries: "",
      createdAt: null,
      updatedAt: null,
    },
  },
  errors: [],
  paymentData: {},
  user: {
    insurances: [],
  },
  resetPasswordState: null,
};

const Context = React.createContext(initialState);

const reducer = (state, action) => {
  console.info(action);
  switch (action.type) {
    case "loading":
      return {
        ...state,
        loading: action.loading,
      };
    case "getInsurance":
      return {
        ...state,
        ...action.data,
        loading: action.loading,
        errors: action.errors,
      };
    case "updateInsuranceLoading":
      return {
        ...state,
        loading: action.loading,
        errors: action.errors,
      };
    case "updateInsuranceSuccess":
      return {
        ...state,
        insurance: {
          ...action.payload,
          creator: action.payload.creator || {},
          packet: action.payload.packet || { includeList: [] },
        },
        loading: action.loading,
        errors: action.errors,
      };
    case "updateInsuranceError":
      return {
        ...state,
        loading: action.loading,
        errors: action.errors,
      };
    case "getInsurancesLoading":
      return {
        ...state,
        loading: action.loading,
        errors: action.errors,
      };
    case "getInsurancesSuccess":
      return {
        ...state,
        user: {
          insurances: action.payload,
        },
        loading: action.loading,
        errors: action.errors,
      };
    case "getInsurancesError":
      return {
        ...state,
        loading: action.loading,
        errors: action.errors,
      };
    case "updateCreatorSuccess":
      return {
        ...state,
        insurance: {
          ...state.insurance,
          creator: {
            ...state.insurance.creator,
            ...action.payload,
          },
        },
        errors: [],
      };
    case "createInsuranceLoading":
      return {
        ...state,
        loading: action.loading,
      };
    case "login":
      return {
        ...state,
        loading: action.loading,
      };
    case "createInsuranceSuccess":
      return {
        ...state,
        insurance: {
          ...action.payload,
          pickedSports: action.payload.pickedSports,
          creator: action.payload.creator || {},
          packet: action.payload.packet || { includeList: [] },
        },
        loading: action.loading,
        errors: [],
      };
    case "createInsuranceError":
      return {
        ...state,
        loading: action.loading,
        errors: action.errors,
      };
    case "payInsuranceLoading":
      return {
        ...state,
        loading: action.loading,
        errors: action.errors,
      };
    case "payInsuranceSuccess":
      return {
        ...state,
        paymentData: action.payload,
        loading: action.loading,
        errors: action.errors,
      };
    case "payInsuranceError":
      return {
        ...state,
        loading: action.loading,
        errors: action.errors,
      };
    case "updateOrderInfo":
      return {
        ...state,
        ...action.data,
        loading: action.loading,
        errors: action.errors,
      };
    case "signUpLoading":
      return {
        ...state,
        loading: action.loading,
        errors: action.errors,
      };
    case "signUpSuccess":
      return {
        ...state,
        ...action.data,
        signup: action.payload.data,
        loading: action.loading,
        errors: action.errors,
      };
    case "signUpError":
      return {
        ...state,
        loading: action.loading,
        errors: action.errors,
      };
    case "signIn":
      return {
        ...state,
        ...action.data,
        loading: action.loading,
        errors: action.errors,
      };
    case "resetPassword":
      return {
        ...state,
        ...action.data,
        resetPasswordState: action.payload,

        loading: action.loading,
        errors: action.errors,
      };
    case "getLocations":
      return {
        ...state,
        ...action.data,
        loading: action.loading,
        errors: action.errors,
      };
    case "getPackets":
      return {
        ...state,
        ...action.data,
        loading: action.loading,
        errors: action.errors,
      };
    case "getSportsLoading":
      return {
        ...state,
        loading: action.loading,
        errors: action.errors,
      };
    case "getSportsSuccess":
      return {
        ...state,
        sports: action.payload || [],
        loading: action.loading,
        errors: action.errors,
      };
    case "getSportsError":
      return {
        ...state,
        loading: action.loading,
        errors: action.errors,
      };
    default:
      return state;
  }
};

const ContextProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const value = { state, dispatch };

  return <Context.Provider value={value}>{children}</Context.Provider>;
};

const ContextConsumer = Context.Consumer;

export { Context, ContextProvider, ContextConsumer };
